import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
    {
        path: '/',
        name: 'MainView',
        component: () => import('../views/MainView.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    let langCode = 'en'
    if (to.query.lang == null || to.query.lang == undefined) {
        var browserLangCode =
            navigator.languages
                ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

        langCode = browserLangCode.substring(0, 2).toLowerCase();
    }
    else {
        langCode = to.query.lang;
    }
    // case "es"
    // case "ru"
    switch (langCode) {
        case "de":
        case "fr":
        case "jp": // ja
        case "pt":
        case "th":
        case "tw": // zh
        case "id":
            break;
        case "ja":
            langCode = 'jp';
            break;
        case "zh":
            langCode = 'tw';
            break;
        default:
            langCode = 'en';
            break;
    }
    store.state.lang = langCode
    next()
});

export default router
